import { useState } from "react";

import { useNavigate } from "react-router-dom";

// MUI
import Stack from "@mui/material/Stack";
import CardMedia from "@mui/material/CardMedia";

// Utils
import { PageGutter, Colors } from "../utils/constants";

// Images
import CodeNationBigText from "../../images/freemium/ctn_parts/ctn_nation.png";
import CodeNationSmallText from "../../images/freemium/ctn_parts/ctn_code.png";
import CodeNationShadow from "../../images/freemium/ctn_parts/ctn_shadow.png";

// Icons
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

const CodeNationBannerTag = ({ href }) => {
    const navigate = useNavigate();
    const [hovered, setHovered] = useState(false);

    const handleNavigate = () => {
        navigate("/" + href);
    };

    return (
        <Stack
            width={270}
            height={108}
            direction={"row"}
            alignItems={"center"}
            justifyContent={"center"}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onClick={handleNavigate}
            sx={{
                marginTop: { xs: "0", md: "-42px" },
                marginBottom: 3,
                marginLeft: { xs: `calc(-${PageGutter} - 8px)` },
                paddingLeft: `calc(${PageGutter} + 8px)`,
                transition: "all 0.3s ease-in-out",
                background:
                    "linear-gradient(99.72deg, #313BF5 3.04%, #0914B0 97.63%)",
                borderTopRightRadius: "24px",
                boxShadow: hovered
                    ? "0px 24px 20px 0px rgba(0, 0, 0, 0.25)"
                    : "0px 16px 20px 0px rgba(0, 0, 0, 0.25)",
                borderBottomRightRadius: "24px",
                zIndex: 1,
                boxSizing: "border-box",
                display: "grid",
                gridTemplateColumns: "1fr",
                gridTemplateRows: "1fr",
                placeItems: "flex-start",
                cursor: "pointer",
            }}
        >
            <Stack
                direction={"row"}
                alignItems={"center"}
                sx={{
                    gridColumn: "1/2",
                    gridRow: "1/2",
                }}
            >
                <Stack sx={{ position: "relative", height: 108 }}>
                    <CardMedia
                        component="img"
                        image={CodeNationShadow}
                        alt="Code The Nation"
                        sx={{
                            height: 108,
                            width: "auto",
                            objectFit: "contain",
                            position: "absolute",
                            zIndex: 1,
                            transition: "all 0.3s ease-in-out",
                        }}
                    />
                </Stack>
                <Stack alignItems={"flex-start"} spacing={1}>
                    <CardMedia
                        component="img"
                        image={CodeNationSmallText}
                        alt="Code The Nation"
                        sx={{
                            height: 14,
                            width: "auto",
                            objectFit: "contain",
                            transition: "all 0.3s ease-in-out",
                            transform: hovered
                                ? "translateX(15px)"
                                : "translateX(5px)",
                        }}
                    />
                    <CardMedia
                        component="img"
                        image={CodeNationBigText}
                        alt="Code The Nation"
                        sx={{
                            height: 23,
                            width: "auto",
                            objectFit: "contain",
                            transition: "all 0.3s ease-in-out",
                            transform: hovered
                                ? "translateX(15px)"
                                : "translateX(0)",
                        }}
                    />
                </Stack>
            </Stack>
            <Stack
                alignItems={"flex-end"}
                justifyContent={"flex-end"}
                sx={{
                    width: "100%",
                    height: "100%",
                    gridColumn: "1/2",
                    gridRow: "1/2",
                    pr: 2,
                    pb: 2,
                }}
            >
                <ArrowForwardRoundedIcon
                    sx={{
                        color: Colors.white,
                        fontSize: 20,
                        transition: "all 0.3s ease-in-out",
                        color: hovered ? Colors.gold : Colors.white,
                    }}
                />
            </Stack>
        </Stack>
    );
};

export default CodeNationBannerTag;
